import constants from "../constants";

const { SHOW_MODAL } = constants;

// eslint-disable-next-line import/prefer-default-export
export const showModal = (data) => ({
  type: SHOW_MODAL,
  data,
});
